namespace PaperTrail.NewsletterControl {
    export interface StoryHighlightRow {
        StoryHighlightId?: number;
        StoryId?: number;
        Text?: string;
        StoryUserId?: number;
        StoryNewsletterId?: number;
        StoryDateSubmitted?: string;
        StoryDateModified?: string;
        StoryDatePublished?: string;
        StoryTitle?: string;
        StorySubtitle?: string;
        StoryPage?: number;
        StoryPosition?: number;
        StoryCharacters?: number;
        StoryDoPageBreak?: boolean;
        StoryRows?: number;
        StoryColumns?: number;
        StoryIsPlaced?: boolean;
        StoryStyleSheetId?: number;
        StoryRank?: number;
        StoryPageTemplateId?: number;
        StoryPageTemplateSectionId?: number;
    }

    export namespace StoryHighlightRow {
        export const idProperty = 'StoryHighlightId';
        export const nameProperty = 'Text';
        export const localTextPrefix = 'NewsletterControl.StoryHighlight';
        export const deletePermission = 'Newsletter:Contributor';
        export const insertPermission = 'Newsletter:Contributor';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Newsletter:Contributor';

        export declare const enum Fields {
            StoryHighlightId = "StoryHighlightId",
            StoryId = "StoryId",
            Text = "Text",
            StoryUserId = "StoryUserId",
            StoryNewsletterId = "StoryNewsletterId",
            StoryDateSubmitted = "StoryDateSubmitted",
            StoryDateModified = "StoryDateModified",
            StoryDatePublished = "StoryDatePublished",
            StoryTitle = "StoryTitle",
            StorySubtitle = "StorySubtitle",
            StoryPage = "StoryPage",
            StoryPosition = "StoryPosition",
            StoryCharacters = "StoryCharacters",
            StoryDoPageBreak = "StoryDoPageBreak",
            StoryRows = "StoryRows",
            StoryColumns = "StoryColumns",
            StoryIsPlaced = "StoryIsPlaced",
            StoryStyleSheetId = "StoryStyleSheetId",
            StoryRank = "StoryRank",
            StoryPageTemplateId = "StoryPageTemplateId",
            StoryPageTemplateSectionId = "StoryPageTemplateSectionId"
        }
    }
}
